<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import api from "../../../services/api";
import Carousel from "../../../components/carousel";
import Swal from "sweetalert2";
import axios from "axios";
import Notebook from "@/services/models/notebook";
import Multiselect from "@/components/RMultiselect.vue";
import ScrollLoad from "@/components/scroll-load.vue";
import ModalTree from "@/components/modal-tree.vue";


export default {
  page: {
    title: "Carnet",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    ScrollLoad,
    Carousel,
    Layout,
    PageHeader,
    Multiselect,
    ModalTree,
  },
  data() {
    return {
      title: "Carnet",
      items: [
        {
          text: "Carnet",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      displayedImages: [],
      singleImage: false,
      currentPage: 1,
      total: 0,
      itemsByPage: 6,
      showSlider: false,
      slide: 0,
      filter: null,
      advanced: {},
      isAllImagesLoaded: false,
      isFetchingNextImages: true,
      cancelToken: null,
      selected: null,
      persons: [],
      years: [],
      year: null,
      showModal: false,
      componentsModal: []
    };
  },
  beforeMount() {
    this.getAllImages();
  },
  mounted() {
    api.get('notebooks', {}, 'years').then((r) => {
      for (const i in r.data) {
        this.years.push({
          value: r.data[i],
          text: r.data[i]
        });
      }
    });
  },
  methods: {
    async getAllImages() {
      await api.getModels(Notebook, {
        params: {
          page: 1,
          length: this.itemsByPage,
          sortBy: 'filename',
          sortDir: 'asc',
          with: 'lafil014.lafil013.persons',
          advanced: this.advanced
        }
      }).then(result => {
        for (const i in result.data.data) {
          this.displayedImages.push(result.data.data[i]);
        }

        this.total = result.data.total;
        this.isAllImagesLoaded = true;
        this.isFetchingNextImages = false;
      });
    },
    getImages() {
      this.isFetchingNextImages = true;

      //Check if there are any previous pending requests
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.")
      }

      //Save the cancel token for the current request
      this.cancelToken = axios.CancelToken.source()

      api.getModels(Notebook, {
        params: {
          page: this.currentPage,
          length: this.itemsByPage,
          sortBy: 'filename',
          sortDir: 'asc',
          filter: this.filter,
          with: 'lafil014.lafil013.persons',
          advanced: this.advanced
        },
        identifier: 'getImages'
      }).then(result => {
        for (const i in result.data.data) {
          this.displayedImages.push(result.data.data[i]);
        }

        this.total = result.data.total;
      }).finally(() => {
        this.isFetchingNextImages = false;
      });
    },
    getImagePath(item, thumbnail) {
      try {
        return [{
          src: '/api/notebooks/' + item.id + '/' + (thumbnail ? 'thumbnail' : 'image'),
          title: item.filename
        }];
      } catch (e) {
        return [{
          src: require(`@/assets/images/missing-img.svg`),
          title: 'missing-img'
        }];
      }
    },
    search() {
      this.displayedImages = [];
      this.currentPage = 1;
      this.total = 0;
      this.getImages();
    },
    selectSlide(item) {
      if (!this.isAllImagesLoaded) {
        Swal.fire("", "La page est en cours de chargement", "error");
        return;
      }

      this.selected = item;
      this.slide = this.displayedImages.findIndex(v => v.id === item.id);

      this.changeSlidePersons(item);

      this.showSlider = true;
    },
    changeSlidePersons(item) {
      this.persons = [];

      if (item.lafil014.length === 0) {
        return;
      }

      for (const lafil014 of item.lafil014) {
        if (!lafil014.lafil013) {
          continue;
        }

        this.persons = this.persons.concat(lafil014.lafil013.persons);
      }
    },
    showModel(v) {
      this.componentsModal = [v.detail()];
      this.showModal = true;
    },
    onSlideStart(e) {
      this.changeSlidePersons(this.displayedImages[e]);
    }
  },
  watch: {
    year(v) {
      if (!v) {
        delete this.advanced.year;
      } else {
        this.advanced.year = v.value;
      }

      this.search();
    },
    filter() {
      this.search();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <b-card>
      <b-card-body>
        <div class="row pb-4">
          <div class="col-sm-12 col-md-5"></div>

          <div class="col-sm-12 col-md-2">
            <b-form-group label="Années">
              <multiselect v-model="year" :options="years" :loading="years.length === 0" :show-labels="false"
                           label="text" track-by="value" placeholder="Choisir votre année"></multiselect>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-5">
            <div id="tickets-table_filter" class="dataTables_filter text-right">
              <label class="d-inline-flex align-items-center">
                Recherche :
                <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Recherche..."
                    class="form-control-sm w-auto"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>

        <b-row v-if="!isAllImagesLoaded">
          <b-col class="text-center">
            <b-spinner class="m-2" small variant="primary" role="status"></b-spinner>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" v-for="(image, index) in displayedImages" :key="index"
                 :style="(index%2===0?'border-right: 1px solid;':'')+'border-bottom: 1px solid;'">
            <div class="mb-0" @click="selectSlide(image)" role="button">
              <b-row no-gutters class="align-items-center">
                <b-col cols="12">
                  <b-card-img-lazy :src="getImagePath(image)[0].src" class="img-fluid"></b-card-img-lazy>
                </b-col>
                <b-col cols="12">
                  <b-card-body>
                    <b-card-title>
                      <h5 class="card-title text-center">{{ image.filename }}</h5>
                    </b-card-title>
                  </b-card-body>
                </b-col>
              </b-row>

            </div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="text-center">
        <scroll-load v-model="currentPage" :total-rows="total" :per-page="itemsByPage"
                     :loading="isFetchingNextImages" @input="getImages()"></scroll-load>
      </b-card-footer>
    </b-card>

    <b-modal centered hide-footer size="xl" v-model="showSlider">
      <carousel :pages="displayedImages" type="notebooks" :set-slide="slide" @sliding-start="onSlideStart"></carousel>

      <blockquote v-if="persons.length !== 0" class="text-capitalize">
        Personnes :
        <template v-for="(model, k) in persons">
          <span :key="model.id" @click="showModel(model)" class="hover-cursor-pointer">{{ model }}</span>
          <template v-if="k + 1 !== persons.length">; </template>
        </template>
      </blockquote>
    </b-modal>

    <modal-tree v-model="showModal" :tree="componentsModal"></modal-tree>
  </Layout>
</template>
